import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  section: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px',
    margin: '0 auto',
    textAlign: 'justify',
    "@media (max-width: 768px)": {
      padding: '20px',
    },
  },
  textContainer: {
    width: '65%',
    textAlign: 'center',
    "@media (max-width: 1540px)": {
      width: '70%'
    },
    "@media (max-width: 1280px)": {
      width: '80%'
    },
    "@media (max-width: 1023px)": {
      width: '90%'
    },
    "@media (max-width: 768px)": {
      width: '95%'
    },
  },
  heading: {
    marginBottom: '20px',
    color: '#243C53',
    fontSize: '48px',
    "@media (max-width: 1540px)": {
      fontSize: '46px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '44px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '42px',
    },
    "@media (max-width: 768px)": {
      fontSize: '40px',
    },
    "@media (max-width: 600px)": {
      fontSize: '38px',
    },
    "@media (max-width: 480px)": {
      fontSize: '36px',
    },
    "@media (max-width: 400px)": {
      fontSize: '34px',
    },
  },
  paragraph: {
    color: '#ffffff',
    fontSize: '28px',
    "@media (max-width: 1540px)": {
      fontSize: '26px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '24px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '22px',
    },
    "@media (max-width: 768px)": {
      fontSize: '20px',
    },
    "@media (max-width: 600px)": {
      fontSize: '18px',
    },
  },
  container: {
    display: 'block',
    width: '100%',
    "@media (min-width: 1023px)": {
      display: "flex",
      justifyContent: "center",
      alignItems: "top",
      textAlign: "center",
    },
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "10px",
  },
  imageWrapper: {
    width: "100px", // Ancho uniforme para todas las imágenes
    height: "125px", // Altura uniforme para todas las imágenes
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden", // Oculta cualquier exceso
  },
  image: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain", // Ajusta la imagen sin deformarla
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#007BFF",
    marginBottom: "10px",
    marginTop: '10px',
    "@media (max-width: 1540px)": {
      fontSize: '22px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '20px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '19px',
    },
    "@media (max-width: 768px)": {
      fontSize: '18px',
    },
    "@media (max-width: 600px)": {
      fontSize: '17px',
    },
    "@media (max-width: 480px)": {
      fontSize: '16px',
    },
    "@media (max-width: 400px)": {
      fontSize: '15px',
    },
  },
  description: {
    fontSize: "24px",
    color: "#333",
    marginTop: '0px',
    "@media (max-width: 1540px)": {
      fontSize: '22px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '20px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '19px',
    },
    "@media (max-width: 768px)": {
      fontSize: '18px',
    },
    "@media (max-width: 600px)": {
      fontSize: '17px',
    },
    "@media (max-width: 480px)": {
      fontSize: '16px',
    },
    "@media (max-width: 400px)": {
      fontSize: '15px',
    },
  },
});

export default useStyles;